import {Injectable} from '@angular/core';
import {ToastController} from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class GeneralService {

    constructor(private toastController: ToastController) {
    }

    setIcon(docType): string {
        switch (docType) {
            case 1: {
                return 'document';
            }
            case 2: {
                return 'trending-down';
            }
            case 3: {
                return 'arrow-undo';
            }
            case 4: {
                return 'logo-euro';
            }
            case 5: {
                return 'pricetag';
            }
            case 6: {
                return 'briefcase';
            }
            case 7: {
                return 'construct';
            }
            case 8: {
                return 'camera';
            }
            case 9: {
                return 'create';
            }
            case 10: {
                return 'shuffle';
            }
            case 12: {
                return 'hammer';
            }
            case 14: {
                return 'flash';
            }
            case 15: {
                return 'bulb';
            }
            case 16: {
                return 'trending-down';
            }
            case 17: {
                return 'hammer';
            }
            case 18: {
                return 'car';
            }
            case 19: {
                return 'book'; 
            }
            case 20: {
                return 'build';
            }
            case 102: {
                return 'bed';
            }
            case 103: {
                return 'swap-horizontal';
            }
            case 104: {
                return 'swap-horizontal';
            }
            case 500: {
                return 'list';
            }
            case 501: {
                return 'cart';
            }
            default: {
                return 'alert';
            }
        }
    }

    async createToast(msg, duration = 1500,bkcolor = 'dark') {
        const toast = await this.toastController.create({
            message: msg,
            duration: duration,
            color: bkcolor
        });
        await toast.present();
    }
}
